import { observer } from "mobx-react-lite";
import pageBuilderStore from "../../../stores/pageBuilderStore";
import {
	DraggableButtons,
	DraggableHeroSlider,
	DraggableColumns,
	DraggableDivider,
	DraggableHeading, DraggableHtml,
	DraggableImage,
	DraggableSocials,
	DraggableText,
	DraggableVideo
} from "./draggable-content-blocks";

/**
 * ContentSection displays the library of draggable content block types
 * (e.g., columns, buttons, headers, text, images, etc.) available for use
 * in the PageBuilder. Users can drag any of these components onto the DesignCanvas
 * to add them to their page or email design.
 *
 * Features:
 * - Renders a grid of draggable block icons/components, one for each supported block type:
 *   Columns, Button, Divider, Heading, Text, Image, Carousel, Video, Socials, HTML.
 * - Each draggable item is implemented as a dedicated `Draggable*` component,
 *   handling the drag initiation and any required drag preview logic.
 * - Organized in a responsive grid for easy scanning and drag operations.
 *
 * @component
 * @remarks
 * - Intended for internal use as part of the SidebarPanel "Content" section in PageBuilder.
 * - Does not accept any props or manage state; all drag logic is encapsulated in child components.
 * - New block types can be added by including their respective `Draggable*` component.
 *
 * @example
 * // Used inside the PageBuilder sidebar content tab:
 * <ContentSection />
 */
export default observer(function ContentSection() {
	return (
    <div>
      <div className="grid grid-cols-3 gap-3 p-4">
        {/* Columns */}
        <DraggableColumns />

        {/* Button */}
        <DraggableButtons />

        {/* Divider */}
        <DraggableDivider />

        {/* Headers */}
        <DraggableHeading />

        {/* Text */}
        <DraggableText />

        {/* Image */}
        <DraggableImage />

        {/* HeroSlider & CarouselSlider (Dual Modes) */}
        {!pageBuilderStore.getIsEmail() && <DraggableHeroSlider />}

        {/* Video */}
        <DraggableVideo />

        {/* Socials */}
        <DraggableSocials />

        {/* HTML */}
        <DraggableHtml />
      </div>
    </div>
  );
});